import { CancelToken } from 'axios';
import { awPortfolioManagementApi } from './Base';
import { GetMasterAssetAllocationRequestParams, GetMasterAssetAllocationResponse } from './types';

const BASE_BENCHMARK_PATH = 'benchmarks/v1/benchmarks';

export function getMasterAssetAllocation(params: GetMasterAssetAllocationRequestParams, cancelToken?: CancelToken) {
  const path = `${BASE_BENCHMARK_PATH}:getMasterAssetAllocation`;
  return awPortfolioManagementApi.get<GetMasterAssetAllocationResponse>(path, { params, cancelToken });
}
